import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Link } from 'react-router';
import Image from '../../components/Image';


class SharedStoryCard extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let sharedStory = this.props.sharedstory;
    let title = this.props.sharedstory.title;
    let wwwPhoto = this.props.sharedstory.www_photo;
    let thumbnailCopy = this.props.sharedstory.thumbnailCopy;

    let storyUrl = '/shared-story-detail/' + this.props.sharedstory.id;


    let coverImageSrc = '';
    coverImageSrc = `thumbnails/?model=sharedstory&id=${sharedStory.id}&size=456x307&source=www_photo`;


    return(
      <main>
        <div className="storyCard-outerWrapper">
          <Link to={storyUrl}><div className="storyCard">



            <div className="storyCard-bannerWrapper">

              <img className="storyCard-bannerFilter" src="/images/stories/shim_stories.gif" />

              <div className="storyCard-banner"><Image className="" src={coverImageSrc} /></div>

            </div>


            <div className="storyCard-body">
              <div className="storyCard-category">
                Member Stories
              </div>

              <div className="storyCard-title">
                {title}
              </div>

              <div className="storyCard-thumbnailCopy">
                {thumbnailCopy}
              </div>

              <div className="storyCard-author">
                Via WorldWideWomen
              </div>

            </div>


          </div></Link>
        </div>


      </main>
    )
  }
}

function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps,
  {
    push,
    Link
  }
)(SharedStoryCard);



// WEBPACK FOOTER //
// ./src/components/sharedStory/SharedStoryCard.jsx